import React from "react";

// Shared modal header used across the app so every dialog has the same
// title / back / close chrome. Pass `onBack` only when a back action applies.
const BackIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M15 6l-6 6 6 6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CloseIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M6 6l12 12M18 6L6 18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const ModalHeader = ({ title, onClose, onBack, className = "" }) => {
  return (
    <div className={`eModalHeader ${className}`.trim()}>
      <div className="eModalHeaderLeft">
        {onBack && (
          <button
            type="button"
            className="eModalIconBtn eModalBackBtn"
            onClick={onBack}
            aria-label="Back"
          >
            <BackIcon />
          </button>
        )}
        {title && <h2 className="eModalTitle">{title}</h2>}
      </div>
      {onClose && (
        <button
          type="button"
          className="eModalIconBtn eModalCloseBtn"
          onClick={onClose}
          aria-label="Close"
        >
          <CloseIcon />
        </button>
      )}
    </div>
  );
};

export default ModalHeader;
